import { PropType, computed, defineComponent, onUnmounted, ref, watch } from 'vue'
import { Store } from 'pinia'
import { gcj02ToBd09 } from '@/utils/coordinateTransform'
import { distanceFormat } from '@/utils/distance'
import { getPowerResourceType } from '@/pages/chargermap/utils/resource'
import { useRoute, useRouter } from 'vue-router'
import { MapViewMode, Marker, MarkerType, Point, ZoomMode } from '../../contract/map'
import { ChargeMapContext } from '../chargerMap/index.model'
import { ComponentActions, ComponentState } from '../../nsh5/localStores/component'
import { EnergyPlanNewDataModel, EnergyResourceModel } from '../../models/plan.model'
import {
  ResourceIconSizeMap,
  ResourceIndexMap,
  ResourceRoutePlanIconMap,
  ResourceRoutePlanIconPointMap,
  ResourceStandbyIndexMap,
} from '../chargerMap/mapConfig'
import { adjustSizeWithZoom, calcSize, changeMarker, fitBound, flyTo } from '../chargerMap/mapUtils'
import EnergyPlans from './energyPlans'

/**
 * 路径规划渲染功能模块
 */
export type EnergyPlanProps = {
  onClickedMarker: (marker: Marker) => void
}
export default defineComponent({
  name: 'energy-plans-view',
  props: {
    mapContextRef: {
      type: Object as PropType<ChargeMapContext>,
    },
    mapInstance: {
      type: Object,
    },
    componentStore: {
      // 用于同一项目功能模块间的通信
      type: Object as PropType<Store<string, ComponentState, {}, ComponentActions>>,
      default: null,
    },
  },
  setup: (props, { expose }) => {
    // 获取组件配置
    const componentsConfig: any = window.NSComponentsConfig
    const mapContextRef = computed(() => props.mapContextRef)
    const mapInstance = computed(() => props.mapInstance)
    const componentStore = computed(() => props.componentStore)
    return () => (
      <>
        {componentStore.value.viewMode === MapViewMode.EnergyPlan &&
          componentsConfig.route_plan.show && (
            <EnergyPlans
              mapContextRef={mapContextRef.value}
              mapInstance={mapInstance.value}
              componentStore={componentStore.value}
            ></EnergyPlans>
          )}
      </>
    )
  },
})
